import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";

import { rootReducer } from "./reducers/";

let composeEnhancers = compose;
let middleware = [thunkMiddleware];
const loggerMiddleware = createLogger();

if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
    middleware = [...middleware, loggerMiddleware];
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
}

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));
